import React from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import DeleteAccount from "../Screens/DeleteAccount";
import Login from "../Screens/Login";
import Dashboard from "../Screens/Dashboard";
import Sidebar from "../Components/Sidebar";
import Collegelist from "../Screens/Managecollege/Collegelist";
import Collegedata from "../Screens/Managecollege/Collegedata";
import Resource from "../Screens/Resource";
import Resorceedit from "../Screens/Resource/edit";
import Auth from "../Components/Auth";


// =========================================================
// M.O.P. ACCESS GUARD
// =========================================================
const CollegeAccessGuard = () => {
  const location = useLocation();

  const collegeId = localStorage.getItem("SDG_COLLEGE_ID");

  // M.O.P. College ID = 1
  if (String(collegeId) === "1") {

    const isMOPDashboard =
      /^\/college\/1\/[^/]+$/.test(location.pathname);

    if (!isMOPDashboard) {
      return (
        <Navigate
          to={`/college/1/${new Date().getFullYear()}`}
          replace
        />
      );
    }
  }

  return <Outlet />;
};


// =========================================================
// APPLICATION LAYOUT
// =========================================================
const MainLayout = () => {
  return (
    <div className="w-full h-full flex">

      <div className="w-[15%] h-full">
        <Auth />
        <Sidebar />
      </div>

      <div className="w-[85%] h-full overflow-y-auto">
        <Outlet />
      </div>

    </div>
  );
};


// =========================================================
// NAVIGATION
// =========================================================
const Navigation = () => {
  return (
    <div className="w-full h-full">

      <Routes>

        {/* =================================================
            MAIN APPLICATION
        ================================================= */}
        <Route
          path="/"
          element={<MainLayout />}
        >

          {/* Access protection */}
          <Route element={<CollegeAccessGuard />}>

            {/* MAIN DASHBOARD */}
            <Route
              index
              element={<Dashboard />}
            />

            {/* COLLEGE LIST */}
            <Route
              path="college"
              element={<Collegelist />}
            />

            {/* COLLEGE DASHBOARD */}
            <Route
              path="college/:id/:flyear"
              element={<Collegedata />}
            />

            {/* RESOURCE */}
            <Route
              path="resource"
              element={<Resource />}
            />

            {/* RESOURCE EDIT */}
            <Route
              path="resource/:id"
              element={<Resorceedit />}
            />

          </Route>

        </Route>
         <Route
          path="/delete-account"
          element={<DeleteAccount />}
        />



        {/* =================================================
            LOGIN
        ================================================= */}
        <Route
          path="/login"
          element={
            <>
              <Auth />
              <Login />
            </>
          }
        />

      </Routes>

    </div>
  );
};

export default Navigation;